export namespace AcademicYearActions {
	export class SetDefaultYear {
		static readonly type = '[AcademicYear] Set Default Year';
		constructor(
			public isEnrollOverrideNextAY: boolean,
			public isEnrollOverrideCurrentAY: boolean
		) {}
	}
}
